import React from 'react';
import './CatecheseItemList.css';
import CatecheseItemCard from './CatecheseItemCard';
import EmptyState from './EmptyState';

/**
 * CatecheseItemList Component
 * 
 * Displays a filterable list of catechism items with a header containing
 * a filter dropdown and an add button
 * 
 * @param {Array} items - Array of items to display
 * @param {Array} etappes - Array of available etappes for filtering
 * @param {string} selectedEtappe - Currently selected etappe filter
 * @param {Function} onEtappeChange - Callback when filter selection changes
 * @param {Function} onAddClick - Callback when add button is clicked
 * @param {Function} onEditItem - Callback when edit button is clicked
 * @param {Function} onExport - Callback when export button is clicked (admin only)
 * @param {boolean} loading - Loading state indicator
 * @param {string} currentUserEmail - Email of the currently logged in user
 * @param {boolean} isAdmin - Whether the current user is an admin
 */
const CatecheseItemList = ({ items, etappes, selectedEtappe, onEtappeChange, onAddClick, onEditItem, onExport, loading, currentUserEmail, isAdmin }) => {
  const normalizeEmail = (value) => (value || '').trim().toLowerCase();
  const normalizedCurrentEmail = normalizeEmail(currentUserEmail);

  const canEditItem = (item) => {
    if (isAdmin) return true;
    if (normalizeEmail(item.createdBy) === normalizedCurrentEmail) return true;

    const toegestaneEmails = Array.isArray(item.toegestaneEmails)
      ? item.toegestaneEmails.map(normalizeEmail).filter(Boolean)
      : [];

    return toegestaneEmails.includes(normalizedCurrentEmail);
  };

  return (
    <div className="item-list-container">
      <div className="list-header">
        <div className="filter-section">
          <label htmlFor="etappe-filter">Filteren op Etappe:</label>
          <select
            id="etappe-filter"
            value={selectedEtappe}
            onChange={(e) => onEtappeChange(e.target.value)}
            className="etappe-select"
          >
            <option value="all">Alle etappes</option>
            {/* Render all etappes except 'all' which is already shown */}
            {etappes
              .filter(etappe => etappe !== 'all')
              .map(etappe => (
                <option key={etappe} value={etappe}>
                  {etappe}
                </option>
              ))
            }
          </select>
        </div>
        <div className="header-actions">
          {isAdmin && (
            <button onClick={onExport} className="export-button">
              Exporteren
            </button>
          )}
          <button onClick={onAddClick} className="add-button">
            + Nieuwe etappe
          </button>
        </div>
      </div>

      {/* Conditional rendering based on loading and data state */}
      {loading ? (
        <div className="loading">Laden...</div>
      ) : items.length === 0 ? (
        <EmptyState
          icon="🗂️"
          message="Geen elementen gevonden"
          hint='Klik op "Nieuwe etappe" om te beginnen'
          actionLabel="Nieuwe etappe"
          onAction={onAddClick}
        />
      ) : (
        <div className="items-grid">
          {items.map(item => (
            <CatecheseItemCard 
              key={item.id} 
              item={item} 
              onEdit={onEditItem}
              canEdit={canEditItem(item)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CatecheseItemList;
